import React from "react";
import i18n from "../../i18n/i18n";
import splashScreenPhoto from "../../images/splash-screen-photo.jpg";
import { withStyles } from 'tss-react/mui';
import {Typography} from "@mui/material";
import {withTranslation} from "react-i18next";

const styles = {
    root: {
        // set up a whole-width image
        position: "fixed",
        width: "100vw",
        height: "calc(100vh - 64px)", // HACK: magic value - toolbar height
        top: "64px", // HACK: magic value - toolbar height
        left: 0,

        backgroundImage: `url(${splashScreenPhoto})`,
        backgroundSize: "cover",
        backgroundClip: "border-box",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#00B2BB",

        padding: "30px 10% 0",
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "flex-start",
    },
    whiteText: {
        color: "#ffffff"
    }
};

class ApplicationRootPage extends React.Component {

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.root}>
                <Typography variant="h3" gutterBottom={true} className={classes.whiteText}>
                    {i18n.t("applicationRootPage:header")}
                </Typography>
                <Typography variant="body1" className={classes.whiteText}>
                    {i18n.t("applicationRootPage:message")}
                </Typography>
            </div>
        );
    }
}

const ApplicationRootPageWithStyles = withStyles(ApplicationRootPage, styles);
export default withTranslation()(ApplicationRootPageWithStyles);